import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';

const RealtimeMonitorPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
          Monitor Realtime
        </h2>

        <p className="text-gray-600 dark:text-gray-400">
          Aquí se visualizarán eventos, conexiones y métricas realtime.
        </p>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default RealtimeMonitorPage;